export default __webpack_public_path__ + "static/media/colorchart.9dffe467.jpg";